import { render, staticRenderFns } from "./FooterDueElle.vue?vue&type=template&id=5bf15ce4"
import script from "./FooterDueElle.vue?vue&type=script&lang=js"
export * from "./FooterDueElle.vue?vue&type=script&lang=js"
import style0 from "./FooterDueElle.vue?vue&type=style&index=0&id=5bf15ce4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports